var module = angular.module('main.customerinvoice');

module.component('caCustomerInvoice',{
    templateUrl: 'main/customerinvoice/customerinvoicesearch/customerinvoicecontent/customerinvoicecontent.cmp.tpl.html',
    bindings: {
        invoiceId: '<',
        navigated: '&'
    },
    controllerAs: 'vm',
    controller: componentController
});

// @ngInject
function componentController($rootScope, $scope, $http, $cookies, DS, $state, $stateParams, $translate, CustomerInvoiceApiService,
    confirmationDialogService, printInvoiceDialogService, loadSpinnerService, ToasterService) {
    var vm = this;

    //Properties
    vm.customerInvoice = {};
    vm.customerInvoiceCopy = {};
    vm.showInvoiceHead = true;
    vm.isEditing = false;

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.toggleInvoiceHead = toggleInvoiceHead;
    vm.canAccess = $rootScope.canAccess;
    vm.getStatusTranslation = getStatusTranslation;
    vm.getTypeTranslation = getTypeTranslation;
    vm.getSelectedInvoiceAsPdf = getSelectedInvoiceAsPdf;
    vm.showInvoicePrintDialog = showInvoicePrintDialog;
    vm.startEdit = startEdit;
    vm.saveEdit = saveEdit;
    vm.cancelEdit = cancelEdit;
    vm.invoiceStatusAllowsEdit = invoiceStatusAllowsEdit;

    function onInit() {
    }
    function onChanges() {
        if (vm.invoiceId) {
            CustomerInvoiceApiService.getById(vm.invoiceId)
                .then(function(response) {
                    vm.customerInvoice = response;
                });
        }
    }

    function toggleInvoiceHead() {
        vm.showInvoiceHead = !vm.showInvoiceHead;
    }

    function getStatusTranslation(text) {
        return $translate.instant('customerinvoice.status' + text);
    }
    function getTypeTranslation(text) {
        return $translate.instant('customerinvoice.type' + text);
    }

    function startEdit() {
        vm.isEditing = true;
        vm.customerInvoiceCopy = angular.copy(vm.customerInvoice);
    }
    function saveEdit() {
        //Change status
        loadSpinnerService.start('mainSpinner', { message: $translate.instant('customerinvoice.savingCustomerInvoice') });
        CustomerInvoiceApiService.saveCustomerInvoice(vm.customerInvoice).then(function(response) {
            if (response && response.id !== 0) {
                vm.customerInvoice = response;
                vm.customerInvoiceCopy = {};
                vm.isEditing = false;

                ToasterService.showSuccess($translate.instant('customerinvoice.customerInvoiceSaved'), $translate.instant('common.success'));
            }
        }, function (error) {
            console.log(error);
            ToasterService.showError(error.message, $translate.instant('common.error'));
            vm.customerInvoice = angular.copy(vm.customerInvoiceCopy);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
            vm.isEditing = false;
        });
    }
    function cancelEdit() {
        vm.isEditing = false;
        vm.customerInvoice = vm.customerInvoiceCopy;
    }

    function isRowInvalid(row) {
        return (
                isTextInvalid(row.intrastatCode) ||
                (!row.weight || row.weight <= 0) ||
                isTextInvalid(row.currencyCode) ||
                isTextInvalid(row.countryOfOriginCode)
                );
    }
    function isTextInvalid(text) {
        return (text === undefined || text.trim().length === 0);
    }

    function allRowsValid() {
        var rowsAreValid = true;
        _.forEach(vm.customerInvoice.invoiceRows, function(row) {
            if (isRowInvalid(row)) {
                rowsAreValid = false;
                return;
            }
        });
        return rowsAreValid;
    }

    function invoiceStatusAllowsEdit() {
        return vm.customerInvoice && vm.customerInvoice.invoiceStatus &&
            vm.customerInvoice.invoiceStatus.invoiceSystemStatus.toLowerCase() === "created";
    }

    function getSelectedInvoiceAsPdf() {
        if (vm.customerInvoice.invoiceStatus.invoiceSystemStatus.toLowerCase() === "invoiced") {
            showInvoicePrintDialog();
        } else if (vm.customerInvoice.invoiceStatus.invoiceSystemStatus.toLowerCase() === "created") {
            //Check that no rows are invalid
            if (!allRowsValid()) {
                ToasterService.showError($translate.instant('customerinvoice.errorNotAllRowsValid'));
                return;
            }

            var confirmationMessage = $translate.instant("customerinvoice.confirmFinalizeInvoice").replace(/%1/g, '<br>');
            confirmationDialogService.showDialog(confirmationMessage).then(function (result) {
                if (result === true) {
                    loadSpinnerService.start('mainSpinner', { message: $translate.instant('customerinvoice.creatingPrint') });
                    CustomerInvoiceApiService.setStatus(vm.invoiceId).then(function(response) {
                        vm.customerInvoice = response;
                        vm.customerInvoice.invoiceStatus.invoiceSystemStatus = "invoiced";
                        showInvoicePrintDialog();
                    }).finally(function () {
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });
        }
    }

    function showInvoicePrintDialog() {
        printInvoiceDialogService.showDialog($translate.instant("analysis.confirmDeleteReport")).then(function (result) {
            if (result.result === true) {
                loadSpinnerService.start('mainSpinner');
                CustomerInvoiceApiService.downloadAsPdf({
                    invoiceId: vm.customerInvoice.id,
                    invoiceNumber: vm.customerInvoice.invoiceNumber,
                    languageCode: result.languageCode,
                    weightSetting: result.weightSetting
                }).finally(function() {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }
}
